<template>
  <div class="menu-children">
    <div class="flex">
      <div class="flex column mr-70" v-for="(item, idx) in menus" :key="idx">
        <router-link
          class="uppercase bold title"
          v-for="(child, index) in item.store_children"
          :key="index"
          :to="set_link(child, item)"
        >
          {{ _.get(child, "title") }}
        </router-link>
        <router-link
          :to="item.full_url"
          key="all"
          class="menu uppercase font-13 bold pointer"
        >
          {{ $fn.tr("ყველას ნახვა") }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import main from "../../mixins/main";
export default {
  mixins: [main],
  props: ["menuId"],
  computed: {
    mall_type() {
      return this.$store.state.main.mallType;
    },
    store_categories() {
      return this.$store.state.main.indx.terms.store_categories;
    },
    menus() {
      let menus = this.makeMenuTree(),
        menus_parent,
        has_children;
      menus_parent = menus.filter(
        m => !m.configs.includes("hide-from-menu") && m.url == this.mall_type
      )[0];
      has_children = menus_parent?.children.filter(ch =>
        ch.configs.includes("has_children")
      );
      has_children?.forEach(child => {
        let taxos = child.secondary_data.filter(
          d => d.contentType == "stores"
        )[0].taxonomies;
        let taxos_type = "" + taxos.store_types[0];

        child.store_children = this.store_categories.filter(
          cat =>
            cat.project &&
            cat.store_type &&
            cat.pid == 0 &&
            cat.show_in_menu &&
            cat.show_in_menu[0] == "yes" &&
            cat.project.includes(taxos.project[0].toString())
        );
        child.store_children = child.store_children.filter(cat =>
          cat.store_type.includes(taxos_type)
        );
      });
      const resultMenu = has_children
        ? has_children.filter(menu => menu.id == this.menuId)
        : [];
      this.$emit("shopMenu", resultMenu);
      return resultMenu;
    }
  },
  methods: {
    set_link(item, parent_menu) {
      let menu_url = parent_menu.full_url;
      let final_url = menu_url + "?cat_id=" + item.id;
      final_url = final_url + "&item_type=" + parseInt(item.pid) + "&page=1";
      return final_url;
    }
  }
};
</script>
<style lang="scss" scoped>
.menu-children {
  @media (max-width: 1023px) {
    margin-top: 0px;
    padding-top: 10px;
  }
  .title {
    color: #4d4d4f;
    font-size: 13px;
    &:hover {
      color: $red;
    }
  }
  a {
    color: #4d4d4f;
    line-height: 24px;
    transition: 0.2s ease;
    &:hover {
      color: $red !important;
    }
    &:last-child {
      &:hover {
        color: $red;
      }
      color: rgba(77, 77, 79, 0.6);
    }
  }
}
</style>
<style lang="scss">
footer {
  .footer {
    &__menu {
      .menu-children {
        .mr-70 {
          margin-right: 0;
          max-width: 90px;
          @media (max-width: 767px) {
            max-width: unset;
          }
        }
        a {
          &.title {
            color: rgb(0, 0, 0);
            font-size: 13px;
            font-family: "Hm-Pangram";
            transition: 0.2s ease;
            line-height: 21px !important;
            &:hover {
              color: $red !important;
            }
          }
          &:last-child {
            display: none;
          }
        }
      }
    }
  }
}
</style>
